// @flow
import * as React from 'react';
import styled from 'styled-components';
import InputMask from 'react-input-mask';
import { Input } from 'statsradio/themes/v3/Stylesheet';

const Element = styled.div`
  display: flex;
  align-items: center;
`;

const LeftElement = styled(Element)`
  margin: 0 ${props => props.theme.V3.metrics.form.input.padding}px;
`;

const RightElement = styled(Element)`
  margin: 0 ${props => props.theme.V3.metrics.form.input.padding}px;
`;

interface Props {
  value: string;

  name: string | void;
  mask: string | void;

  leftElement?: React.Node;
  rightElement?: React.Node;

  onChange?: (value: string) => void;
  onBlur?: () => void;

  style?: Object;
}

function TextInput({ value, mask, name, leftElement, rightElement, onChange, onBlur, style }: Props) {
  function onInputChange(event: SyntheticInputEvent<HTMLInputElement>) {
    event.preventDefault();
    event.stopPropagation();

    onChange && onChange(event.target.value);
  }

  function onInputBlur(event: SyntheticInputEvent<HTMLInputElement>) {
    event.preventDefault();
    event.stopPropagation();

    onBlur && onBlur();
  }

  return (
    <Input>
      {Boolean(leftElement) && <LeftElement>{leftElement}</LeftElement>}

      <InputMask
        mask={mask}

        name={name}
        value={value}

        onChange={onInputChange}
        onBlur={onInputBlur}

        style={style}
      />

      {Boolean(rightElement) && <RightElement>{rightElement}</RightElement>}
    </Input>
  );
}

export default TextInput;



// WEBPACK FOOTER //
// ./src/statsradio/components/ui/forms/TextInput.js